import * as React from "react";
import { ProductListItemContentProps, ProductListItemProps } from "./ProductList.types";
import clsx from "clsx";
import Price from "@Tmp/Price";
import AddToCart from "@Tmp/AddToCart";
import InventoryStatus from "@Tmp/InventoryStatus";
import { useSettings } from "@Tmp/Hooks";
import { Discount } from "@Tmp/Product";

const ProductListItem: React.FC<ProductListItemProps> = (props) => {
    const tmpSettings = useSettings();

    const classes = {
        image_hover: "tmp-product-list__item__image-hover",
    };

    const getImageStyles = () => {
        return {
            backgroundImage: `url('${props.product.image}')`,
        };
    };

    const renderDiscount = () => {
        if (props.product.price_info.has_discount && !tmpSettings.logged_in) {
            return (
                <div className="tmp-product-list__item__save">
                    Spar {props.product.price_info.savings_flat_format + " " + tmpSettings.currency}
                </div>
            );
        }
    };

    const secondaryImage = () => {
        return (
            <div
                className={clsx(
                    "tmp-product-list__item__image-bg",
                    "tmp-product-list__item__image-secondary"
                )}
                style={{ backgroundImage: `url('${props.product.secondary_image}')` }}
            />
        );
    };

    return (
        <div
            className={clsx("tmp-product-list__item", {
                [classes.image_hover]: props.settings?.image_hover_element === "box",
            })}
        >
            <div className="tmp-product-list__item__image">
                <a
                    className={clsx(
                        "tmp-product-list__item__link",
                        "tmp-product-list__item__image-container",
                        {
                            [classes.image_hover]: props.settings?.image_hover_element === "image",
                        }
                    )}
                    href={props.product.url}
                >
                    <div className="tmp-product-list__item__image-bg" style={getImageStyles()} />
                    {props.settings?.image_hover_secondary === "yes" &&
                    props.product.secondary_image !== false
                        ? secondaryImage()
                        : null}
                    <div className="tmp-product-list__item__read-more-container">
                        <button className="tmp-btn tmp-product-list__item__read-more">
                            {props.settings?.read_more ?? "Læs mere"}
                        </button>
                    </div>
                </a>
                <Discount
                    product={props.product}
                    percentage={tmpSettings.logged_in}
                    style={{ top: "1rem" }}
                />
            </div>
            <div className="tmp-product-list__item__content">
                {renderDiscount()}
                {props.settings?.product_elements?.map((item) => (
                    <ProductListItemContent
                        key={item._id}
                        item={item}
                        product={props.product}
                        settings={props.settings}
                    />
                ))}
                <AddToCart product={props.product} settings={props.settings} />
            </div>
        </div>
    );
};

export default ProductListItem;

const ProductListItemContent: React.FC<ProductListItemContentProps> = (props) => {
    const renderItemContent = () => {
        const classId = "elementor-repeater-item-" + props.item._id;
        switch (props.item.product_elements_show) {
            case "title_itemnumber":
                return printTitleAndNumber(classId);

            case "title":
                return printTitle(classId);

            case "itemnumber":
                return printNumber(classId);

            case "description":
                return printDescription(classId);

            case "price":
                return <Price product={props.product} settings={props.settings} />;

            case "inventory":
                return <InventoryStatus product={props.product} settings={props.settings} />;
        }

        return null;
    };

    const printTitleAndNumber = (classId) => {
        return (
            <a
                className={"tmp-product-list__item__link tmp-product-list__item__title " + classId}
                href={props.product.url}
            >
                <span className="tmp-product-list__item__title-text">{props.product.name}</span>
                <span className="tmp-product-list__item__sku">({props.product.sku})</span>
            </a>
        );
    };

    const printTitle = (classId) => {
        return (
            <a
                className={"tmp-product-list__item__link tmp-product-list__item__title " + classId}
                href={props.product.url}
            >
                {props.product.name}
            </a>
        );
    };

    const printNumber = (classId) => {
        return (
            <a
                className={"tmp-product-list__item__link tmp-product-list__item__sku " + classId}
                href={props.product.url}
            >
                {props.product.sku}
            </a>
        );
    };

    const printDescription = (classId) => {
        return (
            <div className={"tmp-product-list__item__discription " + classId}>
                {props.product.description}
            </div>
        );
    };

    return renderItemContent();
};
